import { render, staticRenderFns } from "./vocabularyAudio.vue?vue&type=template&id=4a03d546&scoped=true&"
import script from "./vocabularyAudio.vue?vue&type=script&lang=js&"
export * from "./vocabularyAudio.vue?vue&type=script&lang=js&"
import style0 from "./vocabularyAudio.vue?vue&type=style&index=0&id=4a03d546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a03d546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a03d546')) {
      api.createRecord('4a03d546', component.options)
    } else {
      api.reload('4a03d546', component.options)
    }
    module.hot.accept("./vocabularyAudio.vue?vue&type=template&id=4a03d546&scoped=true&", function () {
      api.rerender('4a03d546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionBank/vocabularyAudio.vue"
export default component.exports